import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import { ADMIN_MENU, STAFF_ADMIN_MENU } from '../../config/ieumConfig';

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.borderLight};
`;

const Content = styled.main`
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
  padding: 24px;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
    padding: calc(74px + env(safe-area-inset-top)) 12px 20px;
    overflow-x: hidden;

    & > * {
      min-width: 0;
    }

    ${({ $staff }) => $staff && `
      padding-bottom: calc(78px + env(safe-area-inset-bottom));
    `}
  }
`;

const AdminLayout = () => {
  const { role } = useAuth();
  const menu = role === 'staff' ? STAFF_ADMIN_MENU : ADMIN_MENU;

  return (
    <Wrapper>
      <Sidebar menu={menu} title={role === 'staff' ? '이음 메일' : '이음 관리자'} />
      <Content $staff={role === 'staff'} data-admin-scroll-container>
        <Outlet />
      </Content>
    </Wrapper>
  );
};

export default AdminLayout;
